import { useContext } from 'react';
import { createContext } from 'react';

import { RichTextProps } from '../@types/RichTextProps';

export const RichTextContext = createContext<RichTextProps>({} as RichTextProps);

RichTextContext.displayName = 'RichText';

const RichTextProvider = (props: RichTextProps) => (
	<RichTextContext.Provider value={props}>{props.children}</RichTextContext.Provider>
);

export const useRichText = () => {
	const context = useContext(RichTextContext);

	return context;
};

export default RichTextProvider;
